import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@flexyoo/environment';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export type IHrSavedFilter = {
  Type: HrSavedFilterType;
  TenantGroupId: number;
  Filter: string;
};

export enum HrSavedFilterType {
  EmployeesList = 'GetEmployeesList',
  EmployeesFundingsOverview = 'GetEmployeesFundingsOverview',
  BenefitTransactionsBenefits = 'GetEmployeeBenefitTransactionsBenefits',
  BenefitTransactionsPayments = 'GetEmployeeBenefitTransactionsPayments',
  WorkerViewBenefitTransactions = 'GetWorkerViewBenefitTransactions',
  TenantBenefitChildrenList = 'GetTenantBenefitChildrenList',
  TCOSimulationList = 'GetEmployeeTCOSimulationList',
  BudgetList = 'GetEmployeeBudgetList',
  MobilityBudgetBenefitList = 'GetMobilityBudgetEmployeeBenefitList',
  NotificationsList = 'GetNotificationsList',
}

@Injectable({ providedIn: 'root' })
export class HrSavedFiltersDataAccessService {
  private readonly http = inject(HttpClient);

  getSavedFilter(type: HrSavedFilterType): Observable<IHrSavedFilter | null> {
    return this.http
      .get<IHrSavedFilter>(`${environment.api}/tenant-group/get-hr-saved-filter`, {
        params: { type },
      })
      .pipe(catchError(() => of(null)));
  }

  setSavedFilter(type: HrSavedFilterType, filter: string | null): Observable<void> {
    return this.http
      .put<void>(`${environment.api}/tenant-group/set-hr-saved-filter`, {
        Type: type,
        Filter: filter,
      })
      .pipe(catchError(() => of(void 0)));
  }
}
